import clsx from "clsx";

interface BrandProps {
  size?: "sm" | "md" | "lg";
  showWordmark?: boolean;
  className?: string;
}

export function Brand({ size = "md", showWordmark = true, className }: BrandProps) {
  const dims = { sm: 28, md: 40, lg: 64 }[size];
  const wordmarkSize = { sm: "text-lg", md: "text-2xl", lg: "text-4xl" }[size];

  return (
    <div className={clsx("inline-flex items-center gap-3", className)}>
      <svg
        viewBox="0 0 64 64"
        width={dims}
        height={dims}
        aria-label="redesip"
        role="img"
      >
        <rect
          x="4"
          y="4"
          width="56"
          height="56"
          rx="10"
          fill="#8DC63F"
          stroke="#1A1A1A"
          strokeWidth="2"
        />
        <text
          x="32"
          y="46"
          textAnchor="middle"
          fontFamily="Outfit, Arial, sans-serif"
          fontWeight="700"
          fontSize="38"
          fill="#fff"
        >
          ip
        </text>
      </svg>
      {showWordmark && (
        <div className="flex flex-col leading-tight">
          <span className={clsx("font-display font-bold text-ink-800", wordmarkSize)}>
            redesip
          </span>
          {size !== "sm" && (
            <span className="text-xs text-ink-500 tracking-wide uppercase">
              CRM
            </span>
          )}
        </div>
      )}
    </div>
  );
}
